import React from 'react';
import './App.css';
import NavBar from './navbar/NavBar';
import Notifications from './notifications/Notifications';
import Stats from './stats/Stats';
import { Route, withRouter, Switch } from 'react-router-dom';
import SignIn from './signin/SignIn';
import authClient from './auth/Auth';
import UserBase from './userBase/UserBase';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.signInCallback = this.signInCallback.bind(this);
    this.envSwitchCallback = this.envSwitchCallback.bind(this);
    this.state = {
      isStaging: false
    }
  }

  signInCallback() {
    this.props.history.replace('/');
  }

  envSwitchCallback(isStaging) {
    this.setState({ isStaging: isStaging });

  }

  componentDidMount() {
    authClient.setCallback(this.signInCallback);
  }
  /**
   * Renders pages based on user authentication, if user signed in
   * render notifications and stats page, if not then display sign-in page
   */
  render() {
    return (
      <div className="App">
        <NavBar id="navBar" callback={this.envSwitchCallback} />
        {
          authClient.getProfile() ?
            <Switch>
              <Route key="notifications" exact path='/'>
                <Notifications isStaging={this.state.isStaging} />
              </Route>
              <Route key="stats" exact path="/stats">
                <Stats isStaging={this.state.isStaging} />
              </Route>
              <Route key="userBase" exact path="/userBase">
                <UserBase isStaging={this.state.isStaging} />
              </Route>
            </Switch>
            // [<Route key="notifications" exact path='/' component={Notifications} />,
            // <Route key="stats" exact path="/stats" component={Stats} />]
            : <Route key="sigin" exact path='/' component={SignIn} />
        }
      </div>
    );
  }
}

export default withRouter(App);